import * as React from 'react';

import { Container } from 'reactstrap';

import * as AidsApi from '../../api/aids';

import Localization from '../../config/localization';

import BackButton from '../../components/BackButton';
import Loader from '../../components/Loader';
import StopSvg from '../../components/Svg/stop';

import Notifications from '../../lib/notifications';
import { DownloadFile } from '../../lib/utils';

import './AdminExportBeneficiary.scss';
import { fileExtension } from '../../constants/file';

class AdminExportBeneficiary extends React.Component<AdminExportBeneficiary.IProps, AdminExportBeneficiary.IState> {
  state = { loading: false, loadingMessage: '', eeCount: 0, gnCount: 0, eeCountAddition: 0, gnCountAddition: 0 };

  componentDidMount() {
    return this._countAids();
  }

  render() {
    return (
      <Container className="admin-export-beneficiary px-5 py-4 my-4">
        <BackButton />

        <Loader loading={this.state.loading} loadingMessage={this.state.loadingMessage} />

        <h4 className="mt-5 eon-title eon-red">{Localization.adminExportBeneficiaryTitle}</h4>
        <p className="mt-3 eon-title eon-middle-grey wrap-pre-line">{Localization.adminExportBeneficiaryInfo}</p>

        <div className="my-5">
          <div className="d-flex">
            <StopSvg />
            <p className="eon-title eon-black text-nowrap my-auto h-100">
              {Localization.formatString(Localization.adminExportBeneficiaryNaturalGasBeneficiary, this.state.gnCount)}
            </p>
          </div>
          <div className="d-flex">
            <StopSvg />
            <p className="eon-title eon-black text-nowrap my-auto h-100">
              {Localization.formatString(Localization.adminExportBeneficiaryElectricEnergyBeneficiary, this.state.eeCount)}
            </p>
          </div>
          <div className="d-flex">
            <StopSvg />
            <p className="eon-title eon-black text-nowrap my-auto h-100">
              {Localization.formatString(Localization.adminExportAdditionNaturalGasBeneficiary, this.state.gnCountAddition)}
            </p>
          </div>
          <div className="d-flex">
            <StopSvg />
            <p className="eon-title eon-black text-nowrap my-auto h-100">
              {Localization.formatString(Localization.adminExportAdditionElectricEnergyBeneficiary, this.state.eeCountAddition)}
            </p>
          </div>
        </div>
        <button className="eon-button bg-eon-red eon-white mt-5" onClick={this._exportBeneficiary}>
          <span className="px-4">{Localization.adminExportBeneficiaryExportButton}</span>
        </button>
      </Container>
    );
  }

  _countAids = async () => {
    try {
      await this.setState({ loading: true });

      const response = await AidsApi.CountAid();

      return this.setState({
        eeCount: response.data.eeCount || 0,
        gnCount: response.data.gnCount || 0,
        eeCountAddition: response.data.eeCountAddition || 0,
        gnCountAddition: response.data.gnCountAddition || 0,
        loading: false
      });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };

  _exportBeneficiary = async () => {
    try {
      await this.setState({ loading: true });

      const response = await AidsApi.GetAdminExport();

      await DownloadFile(response.data, `${Localization.adminExportBeneficiaryFileName}.${fileExtension}`);

      return this.setState({ loading: false });
    } catch (error) {
      Notifications.error(error && error.message);

      return this.setState({ loading: false });
    }
  };
}

export default AdminExportBeneficiary;
